import React from 'react'
import moment from 'moment'
import { Table } from 'antd'

interface Invoice {
  invoiceNumber: string
  sumTotal: number
  pdf: string
  createdAt: string
}

interface Props {
  loading: boolean
  invoices: [Invoice]
}

const InvoiceTable = ({ loading, invoices } : Props) => {
  const columns = [
    {
      title: 'Fakturanummer',
      dataIndex: 'invoiceNumber',
      key: 'invoiceNumber'
    },
    {
      title: 'Fakturadato',
      dataIndex: 'includesLinesOn',
      key: 'includesLinesOn',
      render: (createdAt : string) => {
        return moment(createdAt).format('YYYY-MM-DD')
      },
    },
    {
      title: 'Sum total',
      dataIndex: 'sumTotal',
      key: 'sumTotal'
    },
    {
      title: '',
      dataIndex: 'pdf',
      key: 'pdf',
      render: (pdf: string) => pdf ? <a href={pdf}>Last ned som PDF</a> : <></>
    }
  ]

  return (
    <Table 
      loading={loading}
      size="small"
      pagination={false}
      columns={columns}
      dataSource={invoices.map((invoice) => ({
        ...invoice,
        key: invoice.invoiceNumber,
      }))}
    />
  )
}

export default InvoiceTable
